// extracted by mini-css-extract-plugin
export default {"songs":"Search_songs__T60Y4","search":"Search_search__I504a","searchField":"Search_searchField__Hy8ik"};